import React, { useState } from "react";
import "../Style/Uiuxdoubts.css";

import arrowIcon from "../assets/blue-arrow.png";

const faqData = [
  {
    question: "How do you ensure a user-friendly design?",
    answer:
      "At MPeoples Business Solutions, we follow a user-centered UI/UX design process that focuses on usability, accessibility, and customer behavior. We conduct research, create wireframes, develop interactive prototypes, and perform usability testing to ensure every website and mobile application delivers an intuitive, engaging, and seamless user experience across all devices.",
  },
  {
    question: "What is the difference between UI and UX design?",
    answer:
      "UI (User Interface) Design focuses on the visual appearance of a website or mobile application, including colors, typography, buttons, and layouts. UX (User Experience) Design focuses on how users interact with the product, ensuring easy navigation, functionality, and satisfaction. Together, UI and UX create digital products that are both visually appealing and highly functional.",
  },
  {
    question: "How long does a UI/UX project take?",
    answer:
      "The timeline depends on the project's complexity, features, and business requirements. A simple website UI/UX design may take 2–3 weeks, while complex web applications or enterprise software can require 6–12 weeks. At MPeoples, we maintain transparent communication and provide milestone-based project delivery to ensure quality results.",
  },
  {
    question: "Do you redesign existing websites or apps?",
    answer:
      "Yes. We specialize in redesigning outdated websites and mobile applications to improve user experience, visual appeal, navigation, and conversion rates. Our redesign services focus on modern UI trends, responsive design, faster performance, and improved accessibility while preserving your brand identity.",
  },
  {
    question: "Will I receive source files and design systems?",
    answer:
      "Absolutely. Once your UI/UX project is completed, you'll receive all approved design assets, editable source files (such as Figma), design systems, style guides, and UI components. This makes future updates and product scalability easier for your development team.",
  },
  {
    question: "Do you conduct usability testing?",
    answer:
      "Yes. Usability testing is an essential part of our UI/UX design process. We evaluate navigation, user flows, accessibility, and interaction patterns to identify improvement opportunities before development begins. This helps create digital experiences that maximize user satisfaction and business conversions.",
  },
  {
    question: "Can you align the design with my brand identity?",
    answer:
      "Yes. Every UI/UX design we create reflects your brand's identity, including your logo, colors, typography, design language, and business goals. We ensure consistency across websites, mobile apps, and digital platforms to strengthen brand recognition and deliver a professional customer experience.",
  },
  {
    question: "Why choose MPeoples for UI/UX design services?",
    answer:
      "MPeoples combines user-centered design, modern UI trends, business strategy, and data-driven decision-making to create digital experiences that engage users and generate measurable business results. Our team focuses on usability, performance, scalability, and long-term success.",
  },
];

const Uiuxdoubt = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="uiuxdoubt-section">
      <div className="uiuxdoubt-container">
        <span className="uiuxdoubt-eyebrow">FAQ</span>

        <h2 className="uiuxdoubt-title">
          Frequently Asked Questions About UI/UX Design Services
        </h2>

        <div className="uiuxdoubt-faq-grid">
          {faqData.map((item, index) => (
            <div
              className={`uiuxdoubt-faq-item ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div
                className="uiuxdoubt-faq-question-row"
                onClick={() => toggleFaq(index)}
              >
                <span className="uiuxdoubt-faq-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <h3 className="uiuxdoubt-faq-question">{item.question}</h3>

                <button className="uiuxdoubt-faq-btn" aria-label="Toggle answer">
                  <img
                    src={arrowIcon}
                    alt=""
                    className={`uiuxdoubt-faq-icon ${
                      activeIndex === index ? "rotate" : ""
                    }`}
                  />
                </button>
              </div>

              <div
                className={`uiuxdoubt-faq-answer-wrapper ${
                  activeIndex === index ? "show" : ""
                }`}
              >
                <div className="uiuxdoubt-faq-answer-inner">
                  <p className="uiuxdoubt-faq-answer">{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Uiuxdoubt;